/**
 * add px for values
 * px(1, 2, 3, 4); // returns: 1px 2px 3px 4px
 * @param values
 */
export function px() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return values.map(function (n) { return n + "px"; }).join(' ');
}
